<div class="mb-3" [class.invalid-feedback]="showError">
  @if (props.label && props.hideLabel !== true) {
    <label [attr.for]="id">
      {{ props.label }}
      @if (props.required && props.hideRequiredMarker !== true) {
        <span>*</span>
      }
    </label>
  }

  <div style="display: flex">
    <tui-textfield [tuiTextfieldCleaner]="false" tuiTextfieldSize="s" style="width: 100%">
      @if (!formControl.value) {
        <label tuiLabel i18n="@@VyberiteDiapazonDat">Выберите диапазон дат</label>
      }
      <input
        tuiInputDateRange
        [formControl]="formControl"
        />
      <tui-calendar-range *tuiDropdown/>
    </tui-textfield>

    @if (hasValue) {
      <button nbButton size="small" status="control" (click)="clear()" type="button">
        <tui-icon icon="x"/>
      </button>
    }

  </div>
  @if (showError) {
    <div class="invalid-feedback">
      <formly-validation-message [field]="field" />
    </div>
  }
  @if (props.description) {
    <small class="form-text text-muted">{{ props.description }}</small>
  }
</div>
